import initDialog from '../initDialog'

import { RemoveDialog } from '../RemoveDialog'

import api from '../../../configs/api'

const styles = () => ({});

class RemoveOrganizationDialog extends RemoveDialog
{
    getLocale = () => this.props.locale.dialogs.application.organization.remove ;
}

RemoveOrganizationDialog.defaultProps =
{
    ...RemoveDialog.defaultProps,
    uri    : api.organizations.url,
    useUrl : true
};

RemoveOrganizationDialog.propTypes =
{
    ...RemoveDialog.propTypes
};

export default initDialog({ styles })( RemoveOrganizationDialog );
